<!-- =========================================================================================
    File Name: PinchaaquiStatisticsCard.vue
    Description: Icon card component
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <vx-card class="overflow-hidden">
    <div slot="no-body">
      <div
        class="p-6"
        :class="{
          'flex justify-between flex-row-reverse items-center': iconRight,
        }"
      >
        <feather-icon
          :icon="icon"
          class="p-3 inline-flex rounded-full"
          :class="[`text-${color}`, { 'mb-4': !iconRight }]"
          :style="{ background: `rgba(var(--vs-${color}),.15)` }"
        ></feather-icon>
        <div class="truncate">
          <h2 class="mb-1 font-bold">{{ statistic }}</h2>

          <div class="flex justify-between">
            <span>{{ statisticTitle }}</span>
            <span v-if="percent">
              {{ percent }}%
              <feather-icon
                v-if="typePercent"
                :icon="typePercent == 'down' ? 'ArrowDownIcon' : 'ArrowUpIcon'"
                :svgClasses="[percent == 'down' ? 'text-danger' : 'text-success', 'stroke-current h-4 w-4 mb-1 mr-1']"
              ></feather-icon>
            </span>
          </div>
          <small>{{ statisticSubTitle }}</small>
        </div>
      </div>
    </div>
  </vx-card>
</template>

<script>
import _color from '@/assets/utils/color.js';

export default {
  props: {
    icon: {
      type: String,
      required: true,
    },
    statistic: {
      type: [Number, String],
      required: true,
    },
    statisticTitle: {
      type: String,
    },
    statisticSubTitle: {
      type: String,
    },
    percent: {
      type: String,
    },
    typePercent: {
      type: String,
    },
    color: {
      type: String,
      default: 'primary',
    },
    colorTo: {
      type: String,
    },
    iconRight: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      chartOptions: null,
    };
  },
  watch: {
    themePrimaryColor () {
      this.$refs.apexChart.updateOptions({ theme: { monochrome: { color: this.getHex(this.color) } } });
    },
  },
  computed: {
    themePrimaryColor () {
      return this.$store.state.themePrimaryColor;
    },
  },
  methods: {
    getHex (color) {
      if (_color.isColor(color)) {
        let rgb = window.getComputedStyle(document.documentElement).getPropertyValue(`--vs-${color}`);
        rgb = rgb.split(',');
        return `#${((1 << 24) + (Number(rgb[0]) << 16) + (Number(rgb[1]) << 8) + Number(rgb[2]))
          .toString(16)
          .slice(1)}`;
      }
      return color;
    },
    gradientToColor (color) {
      const gradientToColors = {
        primary: '#A9A2F6',
        success: '#55DD92',
        warning: '#ffc085',
        danger: '#F97794',
      };

      return gradientToColors[color] ? gradientToColors[color] : gradientToColors['primary'];
    },
  },
};
</script>
